import { Container, Stack } from '@chakra-ui/react'
import MainbackSvg from '../assets/images/bg.png'
import MiniBanner from '../components/Site/Banners/MiniBanner'
import Teampeople from '../assets/images/aboutPg/teams.png'
import { useEffect, useState } from 'react'
import SingleLeader from '../components/Site/Leaders/SingleLeader'
import AllTeams from '../components/Site/Teams/AllTeams'
import AhsanIqbal from '../assets/images/ahsaniqbal.png'
import SmRehan from '../assets/images/smrehan2.png'
import SmOvais from '../assets/images/smovais2.png'

export default function Teams() {

  useEffect(() => {
    window.scrollTo({
      top: 0
    })
  }, [])
  

  const [MainLeadersList] = useState([
    {
      image: AhsanIqbal,
      name: 'Ahsan Iqbal',
      designation: 'Chief Executive Officer',
      shortDesignation: '- CEO',
      content: "As we advance, it is crucial that we invest in our employees. INPL has expanded over the past years because we believe in reinventing ourselves every few years. We've developed a culture that enables us to encourage innovation extensively and emphasize on idea development. We want to establish ourselves as a leading global tech company that offers outstanding customer support and lasting value.",
    },
    {
      image: SmOvais,
      name: 'Ovais Rehan',
      designation: 'Chief Operating Officer',
      shortDesignation: '- COO',
      content: "Taking the initiative to serve delicious, freshly made ice cream in an eco-friendly way, Crème Villa overcame many challenges to successfully invent paper packaging in their venture. A company that strongly adheres to its motto despite the norms and obstacles and introduces ice cream in recycled packaging to ensure that the material is bio-degradable. As global warming is taking the hype around the world, small initiatives to go green can go a long way to reduce the effects.",
    },
    {
      image: SmRehan,
      name: 'SM Rehan',
      designation: 'Director',
      shortDesignation: '- DOP',
      content: "Our organization's core value—one that lies at the very center of all we stand for—is ethics. With the impeccable work of our outstanding employees, we have managed to gain the respect and trust of customers around the world. Together, we bring experience, pride, and passion. As we are advancing toward the future, we are looking forward to contributing more to the tech world and being the primary choice of clients.",
    }
  ]);

  return (
    <>
      <Stack
        marginTop={'0 !important'}
        bgImage={MainbackSvg}
        bgSize={'cover'}
        bgRepeat={'no-repeat'}
        bgAttachment={{ base: 'inherit', md: 'fixed' }}
        height={{ base: '40vh', md: '100vh' }}
        display={'flex'}
        justifyContent={{base: 'center', lg: 'flex-end'}}
        position={'relative'}
        zIndex={'1'}
        _after={
          {
            content: '""',
            position: 'absolute',
            bg: '#ffffffd9',
            w: '100%',
            h: '100%',
            zIndex: '-1'
          }
        }
      >
        <MiniBanner simpleHeading={'Our'} strokeHeading={'Team'} banPic={Teampeople} marginLeft={true} />
      </Stack>
      <Stack>
        <Container maxW={{ lg: '6xl', '2xl': '8xl' }}>
          {
            MainLeadersList.map((v, i) => <SingleLeader {...v} key={i} direction={i % 2 !== 0 ? 'row-reverse' : 'row'} />)
          }
        </Container>
      </Stack>
      <Stack>
        <AllTeams />
      </Stack>
    </>
  )
}
